"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _TableSortLabel = _interopRequireDefault(require("@material-ui/core/TableSortLabel"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _Types = require("../util/Types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
/**
*
* @returns default/Link/Custom view
*/
var CustomHeaderCell = function CustomHeaderCell(_ref) {
  var sortOrder = _ref.sortOrder,
    sortBy = _ref.sortBy,
    column = _ref.column,
    _ref$components = _ref.components,
    components = _ref$components === void 0 ? {} : _ref$components,
    toggleSort = _ref.toggleSort;
  var dataField = column.dataField,
    tooltipText = column.tooltipText,
    header = column.header,
    headerType = column.headerType,
    customColHeaderRender = column.customColHeaderRender;
  var Tooltip = (0, _react.useCallback)(function (_ref2) {
    var children = _ref2.children; // return custom tooltips
    if (components.Tooltip) {
      var CustomToolTip = components.Tooltip;
      return /*#__PURE__*/_react.default.createElement(CustomToolTip, null, children);
    }
    // return default tooltip
    if (tooltipText) {
      return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
        id: "header-tooltip",
        title: tooltipText
      }, children);
    }
    // return default view
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_TableCell.default, {
    scope: "col",
    active: sortBy === dataField,
    direction: sortOrder
  }, /*#__PURE__*/_react.default.createElement(Tooltip, null, /*#__PURE__*/_react.default.createElement(_TableSortLabel.default, {
    active: sortBy === dataField,
    hideSortIcon: sortBy !== dataField,
    direction: sortBy === dataField ? sortOrder : 'asc',
    onClick: toggleSort
  }, headerType === _Types.headerTypes.CUSTOM_ELEM && customColHeaderRender ? customColHeaderRender(column) : header)));
};
var _default = CustomHeaderCell;
exports.default = _default;